import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "popup-checklist"
  }, [_c('cell', {
    attrs: {
      "is-link": "",
      "border-intent": false
    },
    nativeOn: {
      "click": function ($event) {
        _vm.isShow = !_vm.isShow;
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._t("title")], 2), _vm.selectValue.length > 0 ? _c('div', {
    staticClass: "value-body"
  }, [_c('label', {
    staticClass: "value"
  }, [_vm._v(" " + _vm._s(_vm._f("dataFilter")(_vm.selectValue, _vm.list)) + " ")])]) : _c('label', {
    staticClass: "placeholder"
  }, [_vm._v(" " + _vm._s(_vm.placeholder) + " ")])]), _c('popup', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }],
    attrs: {
      "show-mask": true,
      "height": _vm.list.length < 5 ? 'auto' : '280px'
    },
    model: {
      value: _vm.isShow,
      callback: function ($$v) {
        _vm.isShow = $$v;
      },
      expression: "isShow"
    }
  }, [_c('popup-header', {
    attrs: {
      "left-text": i18n.tc("11"),
      "right-text": i18n.tc("334"),
      "show-bottom-border": false
    },
    on: {
      "on-click-left": _vm.cancel,
      "on-click-right": _vm.submit
    }
  }), _c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_c('checklist', {
    attrs: {
      "label-position": "left",
      "options": _vm.list
    },
    model: {
      value: _vm.checklist,
      callback: function ($$v) {
        _vm.checklist = $$v;
      },
      expression: "checklist"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };